/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

export const BUZZ_UNREAD_COUNT_EVENT = 'orangehrm-buzz-unread-count';

const BUZZ_MENU_ITEM_SELECTOR = '.oxd-main-menu-item[href*="buzz/viewBuzz"]';

export const publishBuzzUnreadCount = (count) => {
  const normalizedCount = count ?? 0;
  window.dispatchEvent(
    new CustomEvent(BUZZ_UNREAD_COUNT_EVENT, {
      detail: {count: normalizedCount},
    }),
  );
  updateBuzzSideMenuBadge(normalizedCount);
};

export const subscribeBuzzUnreadCount = (handler) => {
  const listener = (event) => {
    handler(event?.detail?.count ?? 0);
  };
  window.addEventListener(BUZZ_UNREAD_COUNT_EVENT, listener);
  return () => window.removeEventListener(BUZZ_UNREAD_COUNT_EVENT, listener);
};

export const isBuzzSideMenuItem = (item) => {
  return (
    item?.icon === 'buzz' ||
    (typeof item?.url === 'string' && item.url.includes('/buzz/viewBuzz'))
  );
};

export const updateBuzzSideMenuBadge = (count) => {
  const label = count > 0 ? (count > 99 ? '99+' : String(count)) : null;

  document.querySelectorAll(BUZZ_MENU_ITEM_SELECTOR).forEach((element) => {
    if (label) {
      element.setAttribute('data-buzz-unread-count', label);
    } else {
      element.removeAttribute('data-buzz-unread-count');
    }
  });
};
